import tw from 'twin.macro';

const Heading = ({ children }) => (
  <h1 className="underlined" css={tw`font-serif text-4xl lg:text-6xl`}>
    {children}
  </h1>
);

export default Heading;
